import React from 'react';

import CountryInfo from '../CountryInfo';

const STIMULUS_SECTION = {
    title: 'Stimulus Package',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">Details</p>
            <ul>
                <li>
                    SAR30bn ($7.99bn) made available to banks and finance
                    companies in return for deferring small- and medium-size
                    businesses’ loans.
                </li>
                <li>
                    SAR13.2bn ($3.52bn) in loans to small and medium-sized
                    enterprises, provided through banks.
                </li>
                <li>SAR6bn ($1.6bn) loan-guarantee programme</li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Saudi Central Bank declares SAR50bn package to combat coronavirus',
            url: 'https://gulfbusiness.com/saudi-central-bank-declares-sar50bn-package-combat-coronavirus/',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'Saudi Arabia',
    lastUpdated: 'March 17, 2020',
    introSection: (
        <p>
            Saudia Arabia has announced a stimulus package worth 13.3bn
            (SAR50bn) stimulus package.
        </p>
    ),
    sections: [STIMULUS_SECTION],
};

const SaudiArabiaInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default SaudiArabiaInfo;
